import { TranslateType } from '../../../../../translation/translationContext.types';
import { WsErrorsEnum } from '../../../chatSocket/constants/webSocketErrors.constants';
import { CustomExceptions, RecognizedExceptions } from '../types/exceptions.type';
import { WsErrorsStrategy } from '../types/wsErrorsStrategy.type';
import { InvalidChatAccessStrategy } from './invalidChatAccess.strategy';
import { InvalidPayloadStrategy } from './invalidPayload.strategy';
import { NonRecognizedExceptionStrategy } from './nonRecognizedException.strategy';
import { RedeB2bErrorStrategy } from './redeB2bError.strategy';
import { TooManyRequestsStrategy } from './tooManyRequestsStrategy.strategy';

export class WsErrorsStrategiesFactory {
  constructor(private readonly translate: TranslateType) {}

  createStrategies() {
    const strategies = new Map<RecognizedExceptions, WsErrorsStrategy>();

    strategies.set(WsErrorsEnum.TOO_MANY_REQUESTS, new TooManyRequestsStrategy(this.translate));
    strategies.set(WsErrorsEnum.REDE_B2B_UNAVAILABLE, new RedeB2bErrorStrategy(this.translate));
    strategies.set(WsErrorsEnum.INVALID_CHAT_ACCESS, new InvalidChatAccessStrategy(this.translate));
    strategies.set(WsErrorsEnum.INVALID_PAYLOAD, new InvalidPayloadStrategy(this.translate));
    strategies.set(
      CustomExceptions.NON_RECOGNIZED_EXCEPTION,
      new NonRecognizedExceptionStrategy(this.translate),
    );

    return strategies;
  }
}
